
function ArchiveStatus() {
    /// <summary>
    /// This object provides js functions for the Widget.DataCenter.ArchiveStatus.vb. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 6.4.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 7.6.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}

ArchiveStatus.prototype = new vcTemplate();

ArchiveStatus.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        me.showInfo("", "", false); 
        //fix the height of the signal list
        me.visual.find("#divList").height(me.height - parseInt(me.visual.find("#divBottom").height(), 10) - parseInt(me.visual.find(".tblHeader").height(), 10));
        me.visual.find(".btnLog").off("click").on("click", function() {me.showLog($(this));});

        return true;
    } catch (ex) { me.writeError('init', ex); return false }

}

ArchiveStatus.prototype.showLog = function (obj) {
    /// <summary>
    /// This function opens the logs for one signal in a modal popup. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        var bsaid = parseInt(obj.attr("data-bsaid"), 10);






        //showModalPopup("<div id='divArchiveLogs'></div>", 420, 770);
        //me.visual.find('#divArchiveLogs').html(me.vcC.getLoadingIcon()).show();
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'loggerid': me.blid, 'day': me.day, 'bsaid': bsaid }),
            function (data) {
                if (data === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                var sTmp = "";
                // ReSharper disable once QualifiedExpressionMaybeNull
                if (data.rows !== null) {
                    var d;
                    var stamp;
                    for (var i = 0; i < data.rows.length; i++) {
                        d = new Date(data.rows[i].timestamp);
                        stamp = $.datepicker.formatDate('dd.mm.yy', data.rows[i].timestamp) + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
                        sTmp += "<b>" + stamp + "</b><br/>" + data.rows[i].changes.replace(/;/g, '<br/>') + "<hr/>";
                    }
                } else {
                    sTmp = me.resources.noEntriesExist;
                }


                var popup = $("<div>").html(sTmp);
                popup.css("overflow-y", "hidden");
                popup.dialog({
                    autoOpen: true,
                    modal: true,
                    width: 420,
                    height: 700,
                    resizable: false,
                    dialogClass: "modal-popup-dialog",
                    title: "",
                    closeOnEscape: true,
                    position: { my: 'top+20%', at: 'top', of: window },

                    buttons: [{
                        text: window._RESOURCES.JS_Com.close_lbl, click: function () {
                            popup.dialog('close');
                            return true;
                        }
                    }]
                });




               // $("#divArchiveLogs").html(sTmp);
                return false;
            });
        return false;
    } catch (ex) {
        me.writeError('showLog', ex);
        return false;
    }
};


ArchiveStatus.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function hides the content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
             me.visual.find("#divList").css("opacity", 0.3);
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};

